import { makeStyles, Theme, Toast } from '@freighthub/silhouette-core'
import { ManualQuoteDialog } from 'features/ManualQuotes'
import { useObserver } from 'mobx-react-lite'
import { FC, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useBetaEnrollment } from 'service/useBetaEnrollment'
import { useRootStore } from 'service/useRootStore'
import { useUnleashFeatureFlags } from 'service/useUnleashFeatureFlags'
import { Loader } from 'view/Loader'

import { FAQDialog } from './Dialogs/FAQDialog'
import { FhDialog } from './Dialogs/FhDialog'
import { TermsAndConditionsDialog } from './Dialogs/TermsAndConditionsDialog'
import { Header } from './Header/Header'
import { LeftBar } from './LeftBar/LeftBar'
import { PageLoader } from './Page/PageLoader'
import { ScrollLayout } from './Page/ScrollLayout'
import { Routes } from './Routes'
import { Snack } from './Snack'

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
  },
  container: {
    display: 'flex',
    flex: '1 0 auto',
  },
  main: {
    position: 'relative',
    flex: '1 0 auto',
  },
  content: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    padding: theme.spacing(2),
    overflow: 'auto',
    backgroundColor: theme.palette.background.default,
  },
  sessionIdText: {
    color: theme.palette.grey[400],
    padding: theme.spacing(2),
  },
  sessionIdDiv: {
    textAlign: 'right',
  },
}))

const AppLayoutComponent: FC = () =>
  useObserver(() => {
    const { localisationStore, uiStore, notificationToastService } = useRootStore()
    const { isFFLoading } = useUnleashFeatureFlags()
    const { shouldDelayAppRendering } = useBetaEnrollment()

    useEffect(() => {
      window.addEventListener('resize', uiStore.checkIfResolutionIsMobile)
      return () => {
        window.removeEventListener('resize', uiStore.checkIfResolutionIsMobile)
      }
    }, [])

    const classes = useStyles()

    if (shouldDelayAppRendering) {
      return <Loader show={shouldDelayAppRendering} />
    }

    return (
      localisationStore.isInitialized && (
        <>
          <div className={classes.root}>
            <Toast
              message={notificationToastService.message}
              open={notificationToastService.isOpen}
              onClose={notificationToastService.hide}
              variant={notificationToastService.variant}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            />
            <Header />
            <div className={classes.container}>
              <LeftBar />
              <main className={classes.main}>
                <ScrollLayout className={classes.content}>
                  <Loader show={isFFLoading} />
                  {/* TODO: Due to this condition, Routes are created twice and effects are also running twice */}
                  {!isFFLoading && <Routes />}
                </ScrollLayout>
                <PageLoader />
              </main>
            </div>
          </div>
          <FhDialog />
          <FAQDialog />
          <TermsAndConditionsDialog />
          <ManualQuoteDialog />
          <Snack />
        </>
      )
    )
  })

export const AppLayout = withRouter(AppLayoutComponent)
